import { defineMessages } from 'react-intl';

export default defineMessages({
  rateCourseTitle: {
    id: 'CourseReviewForm.rateCourseTitle',
    defaultMessage: 'How would you rate this course?',
  },
  currentCourseRatingTitle: {
    id: 'CourseReviewForm.currentCourseRatingTitle',
    defaultMessage: 'Your current course rating',
  },
  courseRatingLabel: {
    id: 'CourseReviewForm.courseRatingLabel',
    defaultMessage:
      'How likely would you recommend this course to your colleagues?',
  },
  courseRatingFeedback: {
    id: 'CourseReviewForm.courseRatingFeedback',
    defaultMessage: 'Feedback',
  },
  likelyLabel: {
    id: 'CourseReviewForm.likelyLabel',
    defaultMessage: 'Likely',
  },
  notLikelyLabel: {
    id: 'CourseReviewForm.notLikelyLabel',
    defaultMessage: 'Not likely',
  },
  saveAndContinueLabel: {
    id: 'CourseReviewForm.saveAndContinueLabel',
    defaultMessage: 'Save and continue',
  },
  skipLabel: {
    id: 'CourseReviewForm.skipLabel',
    defaultMessage: 'Skip',
  },
  closeLabel: {
    id: 'CourseReviewForm.closeLabel',
    defaultMessage: 'Close',
  },
  leaveRatingSuccess: {
    id: 'CourseReviewForm.leaveRatingSuccess',
    defaultMessage: 'Thanks for your rating!',
  },
  maxLength: {
    id: 'General.maxLength',
    defaultMessage: 'Maximum length is {maxCharsQnt} characters',
  },
});
